const Switch = {
  baseStyle: {
    thumb: {
      background: "white",
      transitionProperty: "transform",
      transitionDuration: "200ms",
      borderRadius: "inherit",
      transition: "120ms ease-in-out",
      margin: "0.125rem",
      width: "calc(50% - 0.25rem)",
      height: "calc(100% - 0.25rem)",
      _checked: {
        transform: `translateX(calc(100% + 4px))`
      }
    },
    track: {
      "&[data-focus-visible]": {
        outlineColor: "blue.500",
        outlineOffset: "2px",
        outlineStyle: "solid",
        outlineWidth: "2px"
      },
      transition: "all 120ms ease-in-out 0s",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "flex-start",
      boxSizing: "content-box",
      cursor: "pointer",
      borderRadius: "3rem",
      bgColor: "rgb(156, 174, 189)",
      _hover: {
        bgColor: "rgb(125, 149, 169)"
      },
      _disabled: {
        opacity: "0.5",
        pointerEvents: "none",
        cursor: "not-allowed",
        _hover: {
          bgColor: "rgb(156, 174, 189)"
        }
      },
      _checked: {
        bgColor: "blue.400",
        _hover: {
          bgColor: "rgb(0, 136, 188)",
          borderColor: "rgb(0, 136, 188)"
        }
      },
      _dark: {
        bg: "grayscale.300",
        _checked: {
          bg: "blue.400",
          _hover: {
            bgColor: "rgb(0, 136, 188)",
            borderColor: "rgb(0, 136, 188)"
          }
        },
        _hover: {
          bgColor: "rgb(138, 138, 138)",
          borderColor: "transparent"
        }
      }
    }
  },
  sizes: {
    sm: {
      track: {
        width: "2rem",
        height: "1rem"
      }
    },
    md: {
      track: {
        width: "2.5rem",
        height: "1.25rem"
      }
    },
    lg: {
      track: {
        width: "3rem",
        height: "1.5rem"
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

export { Switch };
